import React from 'react';

export const Youtube = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      height="30"
      width="30"
      viewBox="0 0 30 30"
    >
      <path
        fill="#163e63"
        d="M14.968 0a15 15 0 1015 15 15 15 0 00-15-15zm9.52 19.814a2.5 2.5 0 01-1.757 1.768C21.182 22 14.968 22 14.968 22s-6.214 0-7.768-.418a2.5 2.5 0 01-1.756-1.768A26.147 26.147 0 015.032 15a26.147 26.147 0 01.416-4.814A2.5 2.5 0 017.2 8.418C8.754 8 14.968 8 14.968 8s6.214 0 7.763.418a2.5 2.5 0 011.757 1.768A26.209 26.209 0 0124.9 15a26.209 26.209 0 01-.412 4.814z"
      />
      <path fill="#163e63" d="M12.935 17.955L18.129 15l-5.194-2.955v5.91z" />
    </svg>
  );
};
